import { render } from "./DependentsView.vue?vue&type=template&id=70e6487e&ts=true"
import script from "./DependentsView.vue?vue&type=script&lang=ts"
export * from "./DependentsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__